import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/offboarding/index.js